import { Skeleton, Stack, keyframes, styled } from "@mui/material";

const LoadingDots = styled("div")`
  &:after {
    content: "...";
    animation: ${keyframes`
      0%, 20% {
        content: ".";
      }
      40% {
        content: "..";
      }
      80% {
        content: "...";
      }
    `} 1s infinite;
  }
`;

export const LoadingDotsWithText = ({ text }: { text: string }) => {
  return (
    <div style={{ display: "flex", gap: 1, color: "#7B858B" }}>
      {text} <LoadingDots />
    </div>
  );
};

export const CustomLoadingComponent = () => {
  return (
    <Stack spacing={2} mt={2}>
      <LoadingDotsWithText text="Loading your strategies" />
      <Skeleton height="300px" title="Loading your strategies" animation="wave" variant="rounded" />
    </Stack>
  );
};
